import { APP_RECORD_TYPES } from "vmd-types";

import { RECORD_TYPE_BADGE_COLORS } from "../constants/colors";

type RecordTypeBadgeConfig = {
  label: string;
  backgroundColor: string;
};

export const getRecordTypeBadgeConfig = (
  recordType: string | undefined
): RecordTypeBadgeConfig => {
  if (recordType === APP_RECORD_TYPES.BUSINESS_APPLICATION) {
    return {
      label: "DC Business Apps",
      backgroundColor: RECORD_TYPE_BADGE_COLORS.businessApplication,
    };
  }

  if (recordType === APP_RECORD_TYPES.IT_SERVICE) {
    return {
      label: APP_RECORD_TYPES.IT_SERVICE,
      backgroundColor: RECORD_TYPE_BADGE_COLORS.itService,
    };
  }

  return {
    label: "n/a",
    backgroundColor: RECORD_TYPE_BADGE_COLORS.fallback,
  };
};
